var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicIconWithBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.71 141.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #3fa047;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.86,
    cy: 70.86,
    r: 68.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.85,0C40.09,0,13.85,19.7,4.08,47.15,1.44,54.56,0,62.54,0,70.85c0,39.08,31.78,70.86,70.85,70.86,6.47,0,12.74-.87,18.7-2.51,11.47-3.14,21.79-9.09,30.17-17.07,13.54-12.92,21.99-31.13,21.99-51.28C141.71,31.78,109.93,0,70.85,0Zm-6.57,130.35c-29.92-3.28-53.28-28.71-53.28-59.5,0-5.1,.64-10.06,1.85-14.79l20.6,20.89,16.47,16.71c-.05,.31-.07,.62-.07,.94v12.18c0,4.05,3.29,7.34,7.34,7.34h7.09v16.23Zm51.32-19.79c-4.15-5.89-11.01-9.74-18.77-9.74h-3.67v-26.86c0-1.71-1.4-3.11-3.11-3.11H39.86c-.39,0-.7-.31-.7-.7v-13.51c0-.35,.28-.63,.63-.63h15.15c5.16,0,9.34-4.18,9.34-9.34v-13.81h11.73c8.95,0,16.21-7.26,16.21-16.21v-1.7c22.49,8.61,38.49,30.42,38.49,55.9,0,15.23-5.71,29.14-15.11,39.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIconWithBg);
export default __webpack_public_path__ + "static/media/public_icon_with_bg.0da76410762522604d8724e93f3d6dc4.svg";
export { ForwardRef as ReactComponent };